import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { GridComponent, AggregateService, PageSettingsModel } from '@syncfusion/ej2-angular-grids';

import { GridPageSettings, MetodoRedondeoExpensaEnum, SaveExpensaLiquidacionItemDto, SaveExpensaLiquidacionResponseDto } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-dialogExpensaLiquidacionSimulacion',
  templateUrl: 'dialogExpensaLiquidacionSimulacion.component.html',
  styleUrls: ['./dialogExpensaLiquidacionSimulacion.component.css'],
  providers: [ AggregateService ]
})

export class DialogExpensaLiquidacionSimulacionComponent implements OnInit {

  @ViewChild('ufGrid')
  public ufGrid: GridComponent;

  public pageSizes: number[];
  public ufGridPageSettings: PageSettingsModel;
  public ufGridAllowPaging: boolean = true;
  showFondoOperativoColumn: boolean = false;

  ufTipoGastoPorcentajesFlexValue: number = 15;
  ufLiquidaciones: SaveExpensaLiquidacionResponseDto;
  metodoRedondeoExpensa: any;

  constructor(
    private dialogRef: MatDialogRef<DialogExpensaLiquidacionSimulacionComponent>,
    @Inject(MAT_DIALOG_DATA) public input: SaveExpensaLiquidacionResponseDto
  ) {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.ufGridPageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.ufLiquidaciones = this.input;
  }

  ngOnInit(): void {
    if (this.input != null && this.input.TiposGasto != null && this.input.TiposGasto.length > 0)
      this.ufTipoGastoPorcentajesFlexValue = 65 / (this.input.TiposGasto.length * 2);

    this.metodoRedondeoExpensa = this.ufLiquidaciones?.MetodoRedondeoExpensa;

    this.showFondoOperativoColumn = this.input.UfsLiquidacion.findIndex(x => x.FondoOperativo > 0) >= 0;

    setTimeout(() =>  { 
      if (this.ufGrid.columns != null && this.ufGrid.columns.length > 9)
        this.ufGrid.autoFitColumns();
    }, 300);
  }

  sumUfPrimerVencimiento(uf: SaveExpensaLiquidacionItemDto) {
    var v = uf.Valores.reduce(function (accum, g) { return accum + g.Importe; }, 0);
    return (v ?? 0);
  }

  sumUfSegundoVencimiento(uf: SaveExpensaLiquidacionItemDto) {
    var v = uf.Valores.reduce(function (accum, g) { return accum + g.Importe2; }, 0);
    return (v ?? 0);
  }

  sumUfPorcentaje(gastoId: number) {
    var v = this.input?.UfsLiquidacion?.reduce(function (accumulator, item) {
        var val = item.Valores.filter(x => x.TipoGastoId == gastoId).reduce(function (accum, g) { return accum + g.Porcentaje; }, 0);
        return accumulator + val;
      }, 0);

    return (v ?? 0);
  }

  sumUfImporte(gastoId: number) {
    var v = this.input?.UfsLiquidacion?.reduce(function (accumulator, item) {
        var val = item.Valores.filter(x => x.TipoGastoId == gastoId).reduce(function (accum, g) { return accum + g.Importe; }, 0);
        return accumulator + val;
      }, 0);

    return (v ?? 0);
  }

  sumTotalUfPrimerVencimiento() {
    var v = this.input?.UfsLiquidacion?.reduce(function (accumulator, item) {
        var val = item.Valores.reduce(function (accum, g) { return accum + g.Importe; }, 0);
        return accumulator + val;
      }, 0);

    return (v ?? 0);
  }

  sumTotalUfSegundoVencimiento() {
    var v = this.input?.UfsLiquidacion?.reduce(function (accumulator, item) {
        var val = item.Valores.reduce(function (accum, g) { return accum + g.Importe2; }, 0);
        return accumulator + val;
      }, 0);

    return (v ?? 0);
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  formatRedondeo(): string {
    if (this.metodoRedondeoExpensa === MetodoRedondeoExpensaEnum.RedondeoPorDecimal)
      return '1.4-4';
    return '1.2-2';
  }
  
  pageUfGrid() {
    this.ufGridAllowPaging = !this.ufGridAllowPaging;
  }
}